
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireed96"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireed96"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gAYtL", function(module, exports) {

$parcel$export(module.exports, "fetchObjects", () => $c14eec06dd2f4c2a$export$26e57221e6506c00);
$parcel$export(module.exports, "fetchMyObjects", () => $c14eec06dd2f4c2a$export$cdd05b08d92b04e5);
$parcel$export(module.exports, "fetchObject", () => $c14eec06dd2f4c2a$export$4ed815e9384c6644);
$parcel$export(module.exports, "createObject", () => $c14eec06dd2f4c2a$export$79c7e160a7743efd);
$parcel$export(module.exports, "updateObject", () => $c14eec06dd2f4c2a$export$41b06075337cb84b);
$parcel$export(module.exports, "deleteObject", () => $c14eec06dd2f4c2a$export$39c5ed4ec960eade);
// api-interactions.js
const $c14eec06dd2f4c2a$var$API_BASE_URL = 'https://learningface.ai/objects';
const $c14eec06dd2f4c2a$var$API_MY_OBJECTS_URL = `https://learningface.ai/userObjects`; // Endpoint to get just the users objects
async function $c14eec06dd2f4c2a$export$26e57221e6506c00() {
    try {
        const response = await fetch($c14eec06dd2f4c2a$var$API_BASE_URL);
        if (!response.ok) {
            const message = `Error: ${response.status}`;
            throw new Error(message);
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching objects:', error);
        throw error; // Re-throw for the UI to handle
    }
}
async function $c14eec06dd2f4c2a$export$cdd05b08d92b04e5() {
    console.log(`Fetching user's objects FROM: ${$c14eec06dd2f4c2a$var$API_MY_OBJECTS_URL}`);
    try {
        const response = await fetch($c14eec06dd2f4c2a$var$API_MY_OBJECTS_URL);
        if (!response.ok) {
            const message = `Error: ${response.status}`;
            throw new Error(message);
        }
        // Parse the response JSON once and reuse it
        const data = await response.json();
        console.log('Response data:', data);
        return data;
    } catch (error) {
        console.error('Error fetching objects:', error);
        throw error; // Re-throw for the UI to handle
    }
}
async function $c14eec06dd2f4c2a$export$4ed815e9384c6644(key) {
    try {
        console.log(`Fetching object with key: ${key}`);
        const response = await fetch(`${$c14eec06dd2f4c2a$var$API_BASE_URL}/${key}.json`);
        if (!response.ok) {
            const message = `Error: ${response.status}`;
            const errorDetails = await response.json();
            throw new Error(errorDetails.error || message);
        }
        return await response.json(); // Assuming API returns the object content as text
    } catch (error) {
        console.error(`Error fetching object "${key}":`, error);
        throw error;
    }
}
async function $c14eec06dd2f4c2a$export$79c7e160a7743efd(objectData) {
    try {
        const response = await fetch(`${$c14eec06dd2f4c2a$var$API_BASE_URL}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(objectData)
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to create object');
        }
        return await response.json(); // Or response.text() depending on your API response
    } catch (error) {
        console.error(`Error creating object "${objectData}":`, error);
        throw error;
    }
}
async function $c14eec06dd2f4c2a$export$41b06075337cb84b(key, objectData) {
    try {
        // **IMPORTANT:** You need to implement the PUT endpoint in your server.js
        const response = await fetch(`${$c14eec06dd2f4c2a$var$API_BASE_URL}/${key}.json`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(objectData)
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to update object');
        }
        return await response.json(); // Or response.text()
    } catch (error) {
        console.error(`Error updating object "${key}":`, error);
        throw error;
    }
}
async function $c14eec06dd2f4c2a$export$39c5ed4ec960eade(key) {
    try {
        const response = await fetch(`${$c14eec06dd2f4c2a$var$API_BASE_URL}/${key}.json`, {
            method: 'DELETE'
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Failed to delete object');
        }
        return await response.json(); // Or response.text()
    } catch (error) {
        console.error(`Error deleting object "${key}":`, error);
        throw error;
    }
}

});


parcelRequire("gAYtL");

//# sourceMappingURL=learningface.ai.05db132e.js.map
